import React from 'react';
import LocationLanding from '../components/LocationLanding';
import { locations } from '../data/locations';

export const Kharadi = () => <LocationLanding loc={locations.kharadi} />;
export const Baner = () => <LocationLanding loc={locations.baner} />;
export const Hinjewadi = () => <LocationLanding loc={locations.hinjewadi} />;
export const Mumbai = () => <LocationLanding loc={locations.mumbai} />;
